// libs
import { styled } from '@nykaa/ui-components';

export const CoachmarkWrapper = styled.div`
  position: fixed;
  top: 120px;
  right: 300px;
  z-index: 5;

  > div {
    position: relative;
  }

  .store-toggle-coachmark-pointer-desktop {
    position: absolute;
    top: -${({ theme }) => theme.spacing.spacing60};
    right: ${({ theme }) => theme.spacing.spacing80};
    left: auto;
    transform: rotate(45deg);
  }
`;
